export default __webpack_public_path__ + "static/media/pdf.5316ce9a.png";